// @flow
import * as React from 'react';

import interlaceItems from '../interlace-items';
import { Menu } from '../menu';
import type { MenuInsertions } from '~/core/types';

type propsType = {
    additionalItems?: MenuInsertions
};

const DimmerMenu = ({ additionalItems = [] }: propsType) => {
    return <Menu>{interlaceItems([], additionalItems)}</Menu>;
};

export default DimmerMenu;



// WEBPACK FOOTER //
// ./src/components/bulbs/warm-white/dimmer-menu.js